































import mixins from 'vue-typed-mixins';
import { DataTableHeader, DataTableCompareFunction } from 'vuetify';
import RoleUtils, { Role } from '../../utils/RoleUtils';
export default mixins().extend({
  computed: {
    headers(): DataTableHeader<Role>[] {
      return [
        { text: this.$i18n.tc('model.common.name'), value: 'name' },
        { text: this.$i18n.tc('model.role.type.label'), value: 'type' },
        {
          text: this.$i18n.tc('model.role.sp_privs'),
          value: 'permissions.sp_privs',
        },
        {
          text: this.$i18n.tc('model.role.oversight_privs'),
          value: 'permissions.oversight_privs',
        },
        {
          text: this.$i18n.tc('model.role.oversight_children_privs'),
          value: 'permissions.oversight_children_privs',
        },
      ];
    },
  },
  data(): {
    roles?: Role[];
    search: string;
  } {
    return {
      roles: undefined,
      search: '',
    };
  },
  async mounted() {
    try {
      this.roles = await RoleUtils.api.list();
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
  methods: {
    async create() {
      await this.$router.push({ name: 'role-create' });
    },
    async edit(role: Role) {
      await this.$router.push({
        name: 'role-edit',
        params: { id: `${role.id}` },
      });
    },
    async remove(role: Role) {
      await this.$confirm(
        this.$i18n
          .t('validation.confirmation.delete', [this.$translate(role.name)])
          .toString(),
        async () => {
          if (role.id && this.roles) {
            this.$alert.hide('remove');
            await RoleUtils.api.remove(role.id);

            this.$toast.push({
              type: 'success',
              text: this.$languageobj('validation.success.delete', {
                values: [role.name],
              }),
            });

            const index = this.roles.findIndex((val) => val.id === role.id);
            if (index >= 0) {
              this.roles.splice(index, 1);
            }
          }
        }
      );
    },
  },
});
